import { all, has } from 'ramda';

export const jobIsSkillCompleted = (job, minSkillItems) => has('skills', job) && job.skills.length >= minSkillItems;
export const jobSkillIsFullyCompleted = (job, minSkillItems) =>
	jobIsSkillCompleted(job, minSkillItems) && all(skill => Boolean(skill.selectedLevel), job.skills);

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/components/second-step/required-skills.utils.js